/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { AiType } from '@squiz/dxp-ai-types';
import { CONVERSATIONS } from 'apps/console-core/src/Constants/DxpCapabilities/DxpCapabilityItems.constants';
import { getAiContextPath } from '../Utilities/getAiContextPath';
import { getContentToolPath } from '../Utilities/getContentToolPath';

/**
 * The paths for each Artificial Intelligence screen.
 */
export const screenPaths = {
  aiChatbots: `${CONVERSATIONS.path}/ai-chatbots`,
  conversationsDashboard: CONVERSATIONS.path,
  semanticAuditor: `${CONVERSATIONS.path}/semantic-auditor`,
  semanticAuditorTestBuilder: `${CONVERSATIONS.path}/semantic-auditor/:id`,
  viewAiChatbot: `${CONVERSATIONS.path}/ai-chatbots${getContentToolPath()}`,
  viewAiChatbotContext: `${CONVERSATIONS.path}${getAiContextPath(AiType.chatbot, ':aiId', ':contextId')}`,
};
